import { AutogenLayoutLbReasonsPanel } from "./autogen/AutogenLayoutLbReasonsPanel";

export class lbReasonsPanel extends AutogenLayoutLbReasonsPanel { }
